// import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.esm.browser.min.js'

import {Swiper, Navigation, Pagination} from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { useEffect } from "react"

import "../styles/genreBar.css"



export const GenreBar = ({setSearchParams, searchParams}) =>
{
  useEffect(() =>
  {
      var swiper = new Swiper(".mySwiper", {
        modules: [Navigation, Pagination],
        slidesPerView: 7,
        spaceBetween: 0,
        slidesPerGroup: 7,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints:{0:{
          slidesPerView: 2,
          spaceBetween: 0,

        },300:{
          slidesPerView: 3,
          spaceBetween: 0,
        },450:{
          slidesPerView: 4,
          spaceBetween: 0,
        },600:{
          slidesPerView: 5,
          spaceBetween: 0,
        }, 800:{
          slidesPerView: 6,
          spaceBetween: 0,
        }, 1000:{
          slidesPerView: 7,
          spaceBetween: 0
        }}
        
      })

  }, [])

//filter for genre bar
const GenreFilter = (genre) =>
{
  setSearchParams((params) =>
      {
        if (params.get("genre")===genre) {
          params.delete("genre", genre)
          console.log(searchParams);
        return params 
        }
          params.set("genre", genre);
          return params
      }
      )
}

//styling for clicked genre filters

    return <div class="swiper mySwiper main-container">
    <div class="swiper-wrapper genre-container" id="genre-container">
    <div onClick={() => GenreFilter("Action")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Action" ? {color:"#FF7D63"}:{color:"white"} } >Action</p>
      </div>
      <div onClick={() => GenreFilter("Adventure")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Adventure" ? {color:"#FF7D63"}:{color:"white"} } >Adventure</p>
      </div>
      <div onClick={() => GenreFilter("Comedy")} class="swiper-slide genre-item" id="genre-item">
          <p class="genre-text" style={searchParams.get("genre")==="Comedy" ? {color:"#FF7D63"}:{color:"white"} } >Comedy</p>
      </div>
      <div onClick={() => GenreFilter("Thriller")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Thriller" ? {color:"#FF7D63"}:{color:"white"} } >Thriller</p>
      </div>
      <div onClick={() => GenreFilter("Drama")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Drama" ? {color:"#FF7D63"}:{color:"white"} } >Drama</p>
      </div>
      <div onClick={() => GenreFilter("Animation")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Animation" ? {color:"#FF7D63"}:{color:"white"} } >Family</p>
      </div>
      <div onClick={() => GenreFilter("Fantasy")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Fantasy" ? {color:"#FF7D63"}:{color:"white"} } >Fantasy</p>
      </div>
      <div onClick={() => GenreFilter("History")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="History" ? {color:"#FF7D63"}:{color:"white"} } >History</p>
      </div>
      <div onClick={() => GenreFilter("Horror")} class="swiper-slide genre-item" id="genre-horror">
        <p class="genre-text" style={searchParams.get("genre")==="Horror" ? {color:"#FF7D63"}:{color:"white"} } >Horror</p>
      </div>
      <div onClick={() => GenreFilter("Musical")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Musical" ? {color:"#FF7D63"}:{color:"white"} } >Musical</p>
      </div>
      <div onClick={() => GenreFilter("Mystery")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Mystery" ? {color:"#FF7D63"}:{color:"white"} } >Mystery</p>
      </div>
      <div onClick={() => GenreFilter("Romance")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Romance" ? {color:"#FF7D63"}:{color:"white"} } >Romance</p>
      </div>
      <div onClick={() => GenreFilter("Sci-Fi")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="Sci-Fi" ? {color:"#FF7D63"}:{color:"white"} } >Sci-Fi</p>
      </div>
      <div onClick={() => GenreFilter("War")} class="swiper-slide genre-item" id="genre-item">
        <p class="genre-text" style={searchParams.get("genre")==="War" ? {color:"#FF7D63"}:{color:"white"} } >War</p>
      </div>
    </div>
    <div class="swiper-button-next"/>
    <div class="swiper-button-prev"/>
  </div>
}
